import type { TokenHit } from "@bindery/ja-core";

import { EtymologySlot } from "../n5/etymology-slot";
import { MorphologyDisplay } from "../n5/morphology-display";

export function TokenCard({ token }: { token: TokenHit }) {
  return (
    <div className="flex flex-col gap-2">
      <div className="font-jp-display text-ink text-2xl leading-tight">
        <MorphologyDisplay
          display={token.surface}
          pos={token.pos ?? ""}
          reading={token.reading ?? undefined}
          size="md"
        />
      </div>
      {token.reading && (
        <div className="font-jp-body text-ink/80 text-base">
          {token.reading}
        </div>
      )}
      {token.pos && (
        <div
          className="font-display text-ink/50 text-[0.65rem] tracking-[0.12em] uppercase"
          style={{ fontVariantCaps: "all-small-caps" }}
        >
          {token.pos}
        </div>
      )}
      <EtymologySlot display={token.surface} variant="popover" />
    </div>
  );
}
